import React from 'react'

const Loading = ({setLoading}) => {

    const loadingIcon = {
        fontSize: '2em',
        color: 'var(--blue)',
      };
    
      const loadingOuter = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        alignContent: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        zIndex: '9999',
        color: '#129990',
        backgroundColor: 'rgba(190, 189, 189, 0.11), 0.1)',
      };

  return (
    <>
      <div style={loadingOuter}>
      <i class="fa-solid fa-circle-notch animate__animated animate__rotateIn animate__infinite" style={loadingIcon}></i>
      </div>
    </>
  )
}

export default Loading
